
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/isha-home-school",
      function () {
        return require("private-next-pages/isha-home-school/index.ihs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/isha-home-school"])
      });
    }
  